import addPanelDataConsts from '@/addPanelDataConsts';

export default {
  LIST: addPanelDataConsts.SECTIONS_TYPES.GENERIC_LIST_SECTION,
};
